import React from 'react';
import { useTranslation } from 'react-i18next';

import { Case } from '../../../../shared/api/hscan/case';
import { useCaseListContext } from '../../../../shared/context/CaseListContext';
import detailIcon from '../../assets/icons/icon_detail.svg';

import { ButtonWithIcon } from './ButtonWithIcon';

interface DetailButtonProps {
  caseInfo: Case;
}
export const DetailButton = (props: DetailButtonProps) => {
  const { caseInfo } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.imageDetails',
  });

  const { useGetLinkUrl } = useCaseListContext();
  const getLinkUrl = useGetLinkUrl();
  const onClickButton = async () => {
    const url = await getLinkUrl([caseInfo.caseId]);
    window.open(url, '_blank', 'noopener, noreferrer');
  };

  return (
    <ButtonWithIcon
      $padding="5px"
      $fontSize="12px"
      icon={detailIcon}
      text={`${t('detailButton')}`}
      onClick={onClickButton}
    />
  );
};
